import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import { useAuth } from "../../Common/Configurations/AuthContext";

const initialFieldValues = {
  sourceId: "00000000-0000-0000-0000-000000000000",
  sourceName: "",
  companyId: "",
};

const SourceModal = ({ show, onHide, onSourceCreated, editData }) => {
  const { user } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (user?.cid) {
      setValues((prev) => ({ ...prev, companyId: user.cid }));
    }
  }, [user]);

  useEffect(() => {
    if (editData) {
      setValues(editData);
    } else {
      setValues(initialFieldValues);
    }
  }, [editData]);

  const validate = () => {
    let temp = {};
    temp.sourceName = values.sourceName.trim() !== "";
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const resetAndHide = () => {
    setValues(initialFieldValues);
    setErrors({});
    onHide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      try {
        const isNew =
          values.sourceId === "00000000-0000-0000-0000-000000000000";
        const response = isNew
          ? await apiService.create(config.CREATESOURCE, values)
          : await apiService.update(config.UPDATESOURCE, values);

        if (response && onSourceCreated) {
          onSourceCreated(response.data || response);
        }
        resetAndHide();
      } catch (error) {
        console.error("Failed to save source:", error);
      } finally {
        setBtnLoading(false);
      }
    }
  };

  return (
    <Modal show={show} onHide={resetAndHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {values.sourceId === "00000000-0000-0000-0000-000000000000"
            ? "Add New Source"
            : "Edit Source"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} noValidate>
          <div className="mb-3">
            <label className="form-label">Source Name</label>
            <input
              type="text"
              name="sourceName"
              value={values.sourceName}
              onChange={handleInputChange}
              className={`form-control ${
                errors.sourceName === false ? "is-invalid" : ""
              }`}
              placeholder="Enter source name"
              maxLength={20}
            />
            {errors.sourceName === false && (
              <div className="invalid-feedback">
                Please enter a source name.
              </div>
            )}
          </div>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <button
              type="button"
              className="btn btn-danger"
              onClick={resetAndHide}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={btnLoading}
            >
              {btnLoading
                ? "Saving..."
                : values.sourceId === "00000000-0000-0000-0000-000000000000"
                ? "Save"
                : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default SourceModal;
